import { createContext, useContext } from "react";

// App-level state owned by <App> (above the router) and read by route elements.
// The data router is created once, so its route elements can't close over
// App's changing state; they read it from here instead.
export const AppShellContext = createContext(null);

export const useAppShell = () => useContext(AppShellContext);
